import {MenuNavigationAction} from '@eta/components';

export interface ReduxStateSampleState{
    mycontent?: string;
}


export const CHANGE_MYCONTENT = 'CHANGE_MYCONTENT';

export interface ChangeChangeMyContentAction {
    type: typeof CHANGE_MYCONTENT;
    payload: {
        mycontent: string;
    };
}   

export type ReduxStateSampleActions = ChangeChangeMyContentAction | MenuNavigationAction;